import { HStack } from '@chakra-ui/react';
import { VaultCard } from '@ui/components/Molecules/VaultCard';
import { VaultCardSkeleton } from '@ui/components/Molecules/VaultCardSkeleton';
import useVaultInfoList from '@ui/hooks/contracts/BaraVault/useVaultInfoList';

const VaultCardSection = () => {
  const { data } = useVaultInfoList();

  return (
    <HStack gap={6} flexDir="column" w="full" pt={8}>
      {data
        ? data.map((vault) => <VaultCard {...vault} key={vault.pid} />)
        : Array.from({ length: 3 }).map((_, index) => (
            <VaultCardSkeleton key={index} seq={index} />
          ))}
    </HStack>
  );
};

export default VaultCardSection;
